import { React, useState, useContext, useEffect, useMemo, useRef } from 'react';
import Box from '@iso/components/utility/box';
import ContentHolder from '@iso/components/utility/contentHolder';
import Button from '@iso/components/uielements/button';
import { Form, Input, Radio, Switch, Tooltip } from 'antd';
// import closeIcon from '@iso/assets/images/icon/close-icon.svg';
import closeIcon from '@iso/assets/images/icon/07-icon.svg';
import styled from 'styled-components';
import { SelectOption } from '@iso/components/uielements/select';
import { useLocation, useNavigate } from 'react-router-dom';
import { AppContext } from '../../context/ContextProvider';
import Select from '../Deployments/Deployment.styles';
import { customFilterOption, customSortOptions, hasPermission } from '../../context/helper';
import CustomInfoTooltip from '../Dashboard/CustomComponents/CustomInfoTooltip';
import api from '../../api';
import { AlertContext } from '../../context/alertContext';
import { formatErrors } from '../../context/helper';
import useEnvironmentVariables from '../Dashboard/CustomHooks/useEnvironmentVariables';
import Checkbox from '@iso/components/uielements/checkbox';
import { DeploymentContext } from '../../context/deploymentContext';



const Option = SelectOption;
const { TextArea } = Input

const ProdContentHold = styled.div`
  .isoBoxWrapper {
    height: auto;
    border: none;
    margin: 0;
  }

  .isoHelperText {
    color: red;
    font-weight: 400;
    font-size: 12px;
    margin-top: 10%;
    display: flex;
    justify-content: start;
  }

  .header-text{
    font-size: 14px;
  }
`;

let titleStyle = {
  color: "#1f1f1f",
  fontFamily: "Poppins",
  fontType: "medium",
  fontSize: "16px",
  fontWeight: "500"
}

let subTitleStyle = {
  fontSize: "14px",
  color: "#9b9b9b",
  fontFamily: "Nunito Sans",
  fontType: "regular",
  fontWeight: "400"
}

export default ({
  // handleSubmit,
  data,
  valueFromDropdown,
  update,
  service,
  selectedAppId,
  // form,
  values,
  submitCount,
  onCancel,
  onDelete,
  openDrawer,
  onEditCancel,
  tabSelected,
  currentProject,
  setCurrentProject,
  hasChanges,
  setHasChanges,
  fromEnvironment,
  fromWorkflow,
  serviceSelected,
  setActionPerformed
}) => {


  const { setOpenModel, openRightDrawer, setOpenRightDrawer } = useContext(AppContext);
  const [form] = Form.useForm();

  const [envData, setEnvData] = useState(update ?
    { ...data, value: hasPermission('view_secret') && data.isSecret ? data.value : !data.isSecret ? data.value : "********", lastAction: "Update", valueFrom: data.dependOn ? "Value From" : (data.valueFrom || "Value") } : {
      varName: "",
      valueFrom: fromWorkflow ? "Value" : "",
      valueShown: "",
      value: "",
      originalKey: "", // original key value -> used when updating a variable. This key will be sent
      lastAction: "", // Update, Delete, "" -> last action performed on a particular variable
      isSecret: false,//(!hasPermission('create_secret') && currentProject?.accountDetails?.account_id) ? false : true,
      isHide: false,//(!hasPermission('create_secret') && currentProject?.accountDetails?.account_id) ? false : true,
      dependOn: "",
      value_depend_on: "",
      error: false,
      importFrom: "",
      isNew: true,
      syncProj: false,//(!hasPermission('create_secret') && currentProject?.accountDetails?.account_id) ? false : true,
      injectAt: fromWorkflow ? ["Build Time"] : []
    });
  const [myDropdown, setMyDropdown] = useState([]);
  const [selectedApplicationId, setSelectedApplicationId] = useState(null);
  const [error, setError] = useState({
    status: false,
    msg: "Success"
  });
  const [searchValue, setSearchValue] = useState("");
  const [savingVars, setSavingVars] = useState(false);
  const { set_alertOptions } = useContext(AlertContext);
  // const { encryptSecrets, decryptSecrets } = useProject();
  const { addEnvPayloadGen, updateEnvPayloadGen } = useEnvironmentVariables(currentProject);

  // From deployment context we also need mapIdsWithAppName so the Dependent Service
  // dropdown can show all services (apps, datasources, etc.) by id -> name mapping.
  const { updateDep, mapIdsWithAppName } = useContext(DeploymentContext);

  //console.log("Data: ", data);

  const navigate = useNavigate();
  const location = useLocation();

  // Memoize selected service to avoid repeated find operations
  const selectedService = useMemo(() => {
    if (fromEnvironment && selectedAppId !== null && selectedAppId !== undefined) {
      return currentProject?.tasks?.find(val => val.serviceId === selectedAppId);
    }
    return null;
  }, [fromEnvironment, currentProject?.tasks, selectedAppId]);

  const selectedAccountDetails = useMemo(() => {
    return selectedService?.accountDetails;
  }, [selectedService]);

  // shifter here from top
  const valueFroms = fromWorkflow ? ["Value"] : ["Value", "Value From"];
  let myValueFroms = [];
  valueFroms.map((child, ind) => {
    myValueFroms.push(<Option key={child} name="valueFrom" value={child}>{child}</Option>);
  });

  // Build dropdown options from valueFromDropdown
  // When editing with dependOn, filter to only show options for that service
  // For fromEnvironment, use selectedApplicationId instead of dependOn
  useEffect(() => {
    // Skip building from valueFromDropdown if fromEnvironment (we fetch per service instead)
    if (fromEnvironment) {
      return;
    }
    
    console.log("=== Building dropdown useEffect triggered ===");
    console.log("valueFromDropdown:", valueFromDropdown?.length, valueFromDropdown);
    console.log("update:", update);
    console.log("envData?.dependOn:", envData?.dependOn);
    console.log("data?.dependOn:", data?.dependOn);
    
    let myValues = [];
    
    if (valueFromDropdown && Array.isArray(valueFromDropdown) && valueFromDropdown.length > 0) {
      // If editing and dependOn is set, filter to only that service
      const dependOnId = envData?.dependOn || data?.dependOn;
      console.log("dependOnId for filtering:", dependOnId, "valueFromDropdown length:", valueFromDropdown.length);
      
      const servicesToProcess = update && dependOnId 
        ? valueFromDropdown.filter(temp => {
            const matches = temp.id === dependOnId || temp.id === parseInt(dependOnId) || String(temp.id) === String(dependOnId);
            console.log(`Service ${temp.id} matches ${dependOnId}:`, matches);
            return matches;
          })
        : valueFromDropdown;
      
      console.log("Services to process for dropdown:", servicesToProcess.length, servicesToProcess);
      
      servicesToProcess.forEach((temp, ind) => {
        if (temp.connection_parameters) {
          Object.keys(temp.connection_parameters).forEach((child) => {
            console.log("Adding option - temp.id:", temp.id, "child:", child);
            myValues.push(<Option key={child + "_" + temp.name} name="value" data-alias={temp.id} my-value={child} value={child + "_" + temp.name}>
              <div style={{ display: "flex", justifyContent: "space-between", flexDirection: "column" }}>
                <p style={{ color: "#1f1f1f", fontWeight: "600", fontFamily: "Nunito Sans" }}>{child + "_" + temp.name}</p>
                <div style={{ marginTop: "10px", whiteSpace: "normal" }}>
                  <p style={{ marginRight: "10px", fontFamily: "Nunito Sans", fontSize: "12px" }}>{temp.connection_parameters[child].Description}</p>
                  <p style={{ color: "#4D99EF", fontFamily: "semibold", fontFamily: "Nunito Sans" }}>{temp.connection_parameters[child].Example}</p>
                </div>
              </div>
            </Option>)
          });
        }
      });
    } else {
      console.log("valueFromDropdown is empty or not an array:", valueFromDropdown);
    }
    console.log("Built dropdown options count:", myValues.length);
    setMyDropdown(myValues);
  }, [valueFromDropdown, update, envData?.dependOn, data?.dependOn, fromEnvironment]);

  useEffect(() => {
    if (form) {
      form.setFieldsValue({ ...envData });
    }
  }, [envData]);

  // Intentionally NOT calling form.validateFields() on mount — doing so marks all required
  // fields (e.g. injectAt Checkbox.Group) as errored before the user interacts with them.

  // Initialize dependOn and valueShown from data when editing a "Value From" variable
  useEffect(() => {
    if (update && data && data.valueFrom === "Value From" && data.dependOn) {
      console.log("Initializing Value From variable:", data);
      // Ensure dependOn and valueShown are set correctly
      if (data.dependOn && !envData.dependOn) {
        setEnvData(prev => ({
          ...prev,
          dependOn: data.dependOn,
          valueShown: data.valueShown || prev.valueShown
        }));
      }
      // Initialize selectedApplicationId for deployment context
      if (fromEnvironment && data.dependOn) {
        setSelectedApplicationId(data.dependOn);
      }
    }
  }, [update, data, fromEnvironment]);

  // Track fetched service IDs to prevent duplicate API calls
  const fetchedServiceIdsRef = useRef(new Set());
  const isFetchingRef = useRef(false);

  // Fetch dropdown data if valueFromDropdown is empty but we need it (for editing "Value From" variables)
  useEffect(() => {
    const fetchDropdownIfNeeded = async () => {
      // If editing a "Value From" variable but valueFromDropdown is empty, fetch it
      if (update && data && data.valueFrom === "Value From" && data.dependOn) {
        const dependOnId = data.dependOn;
        
        // Skip if already fetching or already fetched this service
        if (isFetchingRef.current || fetchedServiceIdsRef.current.has(dependOnId)) {
          return;
        }
        
        // Check if we already have data for this service in valueFromDropdown
        const hasDataForService = valueFromDropdown && valueFromDropdown.some(svc => 
          svc.id === dependOnId || svc.id === parseInt(dependOnId) || String(svc.id) === String(dependOnId)
        );
        
        if (!hasDataForService && dependOnId) {
          isFetchingRef.current = true;
          fetchedServiceIdsRef.current.add(dependOnId);
          
          try {
            console.log("Fetching dropdown data for service:", dependOnId);
            const response = await fetch(`${process.env.REACT_APP_API_URI}/api/project_env/${dependOnId}/service-categories-parameters/`, {
              method: 'GET',
              headers: {
                "Authorization": `Bearer ${localStorage.getItem("isAuth")}`,
              }
            });
            const result = await response.json();
            
            if (result.status && result.data) {
              const serviceData = result.data;
              const newServiceData = {
                id: serviceData.id || dependOnId,
                name: serviceData.name || "",
                connection_parameters: serviceData.connection_parameters || {}
              };
              
              console.log("Fetched and setting dropdown data:", newServiceData);
              // Note: We can't call setValueFromDropdown here as it's not passed as prop
              // Instead, we'll build the dropdown directly
              buildDropdownFromServiceData(newServiceData);
            }
          } catch (err) {
            console.log("Error fetching dropdown data:", err);
            // Remove from fetched set on error so it can be retried
            fetchedServiceIdsRef.current.delete(dependOnId);
          } finally {
            isFetchingRef.current = false;
          }
        }
      }
    };
    
    fetchDropdownIfNeeded();
  }, [update, data, valueFromDropdown]);

  // Helper function to build dropdown from a single service's data
  const buildDropdownFromServiceData = (serviceData) => {
    if (!serviceData || !serviceData.connection_parameters) return;
    
    let myValues = [];
    Object.keys(serviceData.connection_parameters).map((child) => {
      myValues.push(<Option key={child + "_" + serviceData.name} name="value" data-alias={serviceData.id} my-value={child} value={child + "_" + serviceData.name}>
        <div style={{ display: "flex", justifyContent: "space-between", flexDirection: "column" }}>
          <p style={{ color: "#1f1f1f", fontWeight: "600", fontFamily: "Nunito Sans" }}>{child + "_" + serviceData.name}</p>
          <div style={{ marginTop: "10px", whiteSpace: "normal" }}>
            <p style={{ marginRight: "10px", fontFamily: "Nunito Sans", fontSize: "12px" }}>{serviceData.connection_parameters[child].Description}</p>
            <p style={{ color: "#4D99EF", fontFamily: "semibold", fontFamily: "Nunito Sans" }}>{serviceData.connection_parameters[child].Example}</p>
          </div>
        </div>
      </Option>);
    });
    
    console.log("Built dropdown from service data:", myValues.length, "options");
    setMyDropdown(prev => {
      // Merge with existing dropdown, avoiding duplicates
      const existingKeys = new Set(prev.map(opt => opt.key));
      const newOptions = myValues.filter(opt => !existingKeys.has(opt.key));
      return [...prev, ...newOptions];
    });
  };


  const handelClick = () => {
    console.log("location.state: ", location.state);
    setOpenRightDrawer({
      drawerType: false,
      drawerProps: {
        data: "",
        columnId: ""
      },
    });
  }

  const handelInputChange = (e) => {
    console.log("inside handelInputChange");
    let val = e.target.value;
    if (e.target.name === "value") {
      // Allow spaces in value field
      // pass
    }
    else {
      val = val.replace(/\s/g, '');
    }
    if (e.target.name === "value") {
      console.log("Env data: ", envData);
      setEnvData({
        ...envData,
        [e.target.name]: val,
        dependOn: null,
        error: val ? false : true
      });

    }
    else {
      if (e.target.name === "varName") {
        if (!update) {
          setEnvData({ ...envData, [e.target.name]: val, error: val ? false : true, originalKey: val });
        }
        else {
          setEnvData({ ...envData, [e.target.name]: val, error: val ? false : true });
        }
      }
      else {
        setEnvData({ ...envData, [e.target.name]: val, error: val ? false : true });
      }
    }
    form.setFieldValue(e.target.name, val);
    setError({ ...error, status: false });
  }

  const handleServiceSelect = (applicationId) => {
    setSelectedApplicationId(applicationId);
    setEnvData({
      ...envData,
      dependOn: applicationId,
      value: "",
      valueShown: "",
    });
    form.setFieldValue("value", "");
    form.setFieldValue("valueShown", "");
    // Clear dropdown when service changes
    setMyDropdown([]);
  };

  // Fetch dropdown data when selectedApplicationId changes (for fromEnvironment)
  // We resolve the display name from mapIdsWithAppName so that all kinds of
  // services (apps, datasources, etc.) are available in the dropdown.
  useEffect(() => {
    if (fromEnvironment && selectedApplicationId && envData.valueFrom === "Value From") {
      const fetchDropdownForService = async () => {
        try {
          const response = await fetch(`${process.env.REACT_APP_API_URI}/api/project_env/${selectedApplicationId}/service-categories-parameters/`, {
            method: 'GET',
            headers: {
              "Authorization": `Bearer ${localStorage.getItem("isAuth")}`,
            }
          });
          const result = await response.json();
          
          if (result.status && result.data) {
            const serviceData = result.data;
            const mapName =
              mapIdsWithAppName?.[selectedApplicationId] ??
              mapIdsWithAppName?.[String(selectedApplicationId)];

            buildDropdownFromServiceData({
              id: serviceData.id || selectedApplicationId,
              name: mapName || serviceData.name || "",
              connection_parameters: serviceData.connection_parameters || {}
            });
          }
        } catch (err) {
          console.log("Error fetching dropdown data for service:", selectedApplicationId, err);
        }
      };
      
      fetchDropdownForService();
    }
  }, [selectedApplicationId, fromEnvironment, envData.valueFrom, mapIdsWithAppName]);

  const handleSelectChange = (value, event) => {
    console.log("value inside handleSelectChange :", value);
    console.log("event inside handleSelectChange :", event);
    if (event.name === "value") {
      console.log("event alias: ", event);
      setEnvData({
        ...envData,
        [event.name]: event["my-value"],
        valueShown: value,
        dependOn: event["data-alias"],
        error: value ? false : true,
      });
    }
    else {
      setEnvData({
        ...envData,
        [event.name]: value,
        value: "",
        valueShown: "",
        isSecret: value === "Value From" ? false : envData.isSecret,
        isHide: value === "Value From" ? false : envData.isSecret,
        error: value ? false : true,
      });
      // Clear dependOn and selectedApplicationId when switching away from "Value From"
      if (value !== "Value From") {
        setEnvData(prev => ({
          ...prev,
          dependOn: "",
        }));
        setSelectedApplicationId(null);
        setMyDropdown([]);
      }
      form.setFieldValue("valueFrom", null);
    }
    setError({ ...error, status: false });
  }

  const handelCreate = async (e, addAnother) => {
    console.log("inside handelCreate envData:", envData, location.state);
    console.log("inside handelCreate currentProject:", currentProject);
    console.log("inside handelCreate selectedAppId:", selectedAppId);
    console.log("inside handelCreate data.id:", data.id);
    try {
      if (form) {
        const values = await form.validateFields();
        console.log('Success:', values);
      }
      let allNames = [];
      let hasSecret = 0;
      console.log("My service: ", service);
      // if (service) {
      //   service.envs.map((temp) => {
      // Use currentProject service data if fromEnvironment, otherwise use service prop
      const serviceToUse = fromEnvironment && selectedService ? selectedService : service;
      if (serviceToUse) {
        (serviceToUse.envs || []).filter((temp) => temp != null && temp.lastAction !== "Delete").map((temp) => {
          if(temp.isSecret) {
            hasSecret += 1;
          }
          allNames.push(temp.varName);
        });
      }

      if (allNames.includes(envData.varName)) {
        setError({
          status: true,
          msg: "Variable name already exist. Please provide unique variable name."
        });
        form.setFields([{
          name: "varName",
          errors: ["Variable name already exist. Please provide unique variable name."]
        }]);
      }
      else if (envData.varName.startsWith(" ") || envData.varName.endsWith(" ")) {
        setError({
          status: true,
          msg: "Please remove any leading or trailing spaces from variable name."
        });
      }
      else {
        setError({ ...error, status: false });
        console.log("current project in add...", currentProject, data);
        //in case of environment section, data prop becomes different in case of adding and updating env vars.
        //adding doesn't have tempId whereas updating has it(tempId = serviceId)
        currentProject.tasks.map((temp, idx) => {
          if (temp.id === data.id) {
            // let tempEnvData = {...envData}

            currentProject.tasks[idx].envs.unshift(envData);
            // currentProject.tasks[idx]["hasSecrets"] = hasSecret > 0 ? true : false;
          }
        });
        if (!fromEnvironment && currentProject.tasks[selectedAppId]) {
          currentProject.tasks[selectedAppId].appError = false
        };

        console.log("fromEnvironment, hasSecret :", fromEnvironment, hasSecret);
        // open secret_name pop up if first time added env_vars
        // if(fromEnvironment && selectedAccountDetails !== "Atmosly" && envData.isSecret && hasSecret == 0) {
        //   let secretName = currentProject.tasks.find(val => val.id === data.id)?.secret_name;
        //   console.log("secretName :", secretName);
        //   setOpenModel({
        //     modalType: 'CHANGE_SECRET_NAME',
        //     modalProps: {
        //         data: {
        //           name: secretName
        //         },
        //         title: "Change Secret Name",
        //         subTitle: "",
        //         cancelButton: "Cancel",
        //         saveButton: "Change",
        //         onChange: (taskName) => {
        //             console.log("onChange :", taskName);
        //             currentProject.tasks.map((temp, idx) => {
        //               if (temp.id === data.id) {
        //                 // let tempEnvData = {...envData}
            
        //                 currentProject.tasks[idx].secret_name = taskName;
        //               }
        //             });

        //             setCurrentProject({ ...currentProject, tasks: [...currentProject.tasks] });
        //             localStorage.setItem(!fromEnvironment ? "Project" : "ProjectDep", JSON.stringify({ ...currentProject, tasks: [...currentProject.tasks] }));
                    
        //             // Close this if user confirmed execution
        //             setOpenModel({
        //                 modalType: false,
        //                 modalProps: {
        //                     data: ""
        //                 },
        //             });
        //         },
        //         handleCancel: () => { 
        //           console.log("onCancel");
        //           setOpenModel({
        //             modalType: false,
        //             modalProps: {
        //                 data: ""
        //             },
        //           });
        //         },
        //         columnId: null,
        //         className: "large-Box"
        //     },
        //   });
        // }
        // else 
        // if(fromWorkflow && currentProject?.accountDetails !== "Atmosly" && envData.isSecret && hasSecret == 0) {
        //   let secretName = currentProject?.accountDetails?.secret_name;
        //   console.log("secretName :", secretName);
        //   setOpenModel({
        //       modalType: 'CHANGE_SECRET_NAME',
        //       modalProps: {
        //           data: {
        //               name: secretName
        //           },
        //           title: "Change Secret Name",
        //           subTitle: "",
        //           cancelButton: "Cancel",
        //           saveButton: "Change",
        //           onChange: (taskName) => {
        //               console.log("onChange :", taskName);
        //               currentProject.accountDetails.secret_name = taskName;
  
        //               setCurrentProject({ ...currentProject });
        //               localStorage.setItem("Project", JSON.stringify({ ...currentProject }));
                      
        //               // Close this if user confirmed execution
        //               setOpenModel({
        //                   modalType: false,
        //                   modalProps: {
        //                       data: ""
        //                   },
        //               });
        //           },
        //           handleCancel: () => { 
        //               console.log("onCancel");
        //               setOpenModel({
        //               modalType: false,
        //               modalProps: {
        //                   data: ""
        //               },
        //               });
        //           },
        //           columnId: null,
        //           className: "large-Box"
        //       },
        //   });
        // }

        // set current project to update
        setCurrentProject({ ...currentProject, tasks: [...currentProject.tasks] });
        localStorage.setItem(!fromEnvironment ? "Project" : "ProjectDep", JSON.stringify({ ...currentProject, tasks: [...currentProject.tasks] }));
        if (!hasChanges) {
          if (!fromEnvironment) {
            if (envData.isSecret && currentProject?.accountDetails?.account_id) {
              console.log("getting env vars....");
              handelSaveEnvVar(true);
            }
            else {
              handelSaveEnvVar(false);
            }
          }
          else {
            if (envData.syncProj) {
              if (envData.isSecret && selectedAccountDetails?.account_id) {
                console.log("getting env vars....");
                // handelSaveEnvVar(true);
                handelSaveEnvVar(false);
              }
              else {
                handelSaveEnvVar(false);
              }
            }
          }
        }
        else {
          if (fromWorkflow) {
            // pass
          }
          else if (!fromEnvironment) {
            setActionPerformed(true);
          }
        }
        // setHasChanges(true);

        if (addAnother) {
          setEnvData({
            varName: "",
            valueFrom: "",
            value: "",
            isSecret: fromWorkflow ? false : true,
            isHide: true,
            dependOn: "",
            value_depend_on: "",
            error: false,
            originalKey: "", // original key value -> used when updating a variable. This key will be sent
            lastAction: "", // Update, Delete, "" -> last action performed on a particular variable
            isHide: true,
            importFrom: "",
            isNew: true,
            syncProj: false,
            injectAt: fromWorkflow ? ["Build Time"] : [],
          });
        }
        else {
          console.log("my click");
          handelClick();
        }
      }
    }
    catch (err) {
      // Bring the first validation error into view (e.g., injectAt -> "Please select environment variable type")
      const firstErrorField = err?.errorFields?.[0]?.name;
      if (firstErrorField && form.scrollToField) {
        form.scrollToField(firstErrorField, { behavior: "smooth", block: "center" });
      } else if (typeof window !== "undefined" && window.scrollTo) {
        window.scrollTo({ top: 0, behavior: "smooth" });
      }
      console.log("Inside handelCreate Error :", err);
    };
  }

  // useEffect(() => {
  //   if(fromEnvironment){
  //     console.log("inside useEffect currentProject:", currentProject);
  //     console.log("inside useEffect data.id:", data.id);
  //     console.log("inside useEffect data.id:", serviceSelected);
  //     let secretName = currentProject.tasks.find(val => val.id === data.id)?.secret_name;
  //     setOpenModel({
  //       modalType: 'CHANGE_SECRET_NAME',
  //       modalProps: {
  //           data: {
  //             name: secretName
  //           },
  //           title: "Change Secret Name",
  //           subTitle: "",
  //           cancelButton: "Cancel",
  //           saveButton: "Change",
  //           onChange: (taskName) => {
  //               console.log("onChange :", taskName);
  //               setCurrentProject((prev) => {
  //                 let tempData = { 
  //                   ...prev,
  //                   tasks: prev.tasks.map((item) => item.id === data.id ? { ...item, secret_name: taskName } : item)
  //                 }

  //                 // localStorage.setItem("ProjectDep", JSON.stringify(tempData));

  //                 console.log("tempData :", tempData);
  //                 return prev;
  //               });
  //               // Close this if user confirmed execution
  //               // setOpenModel({
  //               //     modalType: false,
  //               //     modalProps: {
  //               //         data: ""
  //               //     },
  //               // });
  //           },
  //           handleCancel: () => { console.log("onCancel") },
  //           columnId: null,
  //           className: "large-Box"
  //       },
  //     });
  //   }
  // }, []);

  const handelUpdate = async (e) => {
    console.log("inside handelUpdate envData:", service, envData, data, location.state);
    console.log("inside handelUpdate currentProject:", currentProject);
    try {
      // const values = await form.validateFields();
      // console.log('Success:', values);
      if (form) {
        const values = await form.validateFields();
        console.log('Success:', values);
      }
      let allNames = [];
      let ctr = 0; //counts how many times the variables get repeated
      // console.log("Environment data: ", service.envs);
      // service.envs.map((temp) => {
      // Use currentProject service data if fromEnvironment, otherwise use service prop
      const serviceToUse = fromEnvironment && selectedService ? selectedService : service;
      console.log("Environment data: ", serviceToUse?.envs);
      (serviceToUse?.envs || []).filter((temp) => temp != null && temp.lastAction !== "Delete").map((temp) => {
        // check if the key of the variable was changed. 
        // If it gets changed, compare the variables with varName(updated key) for variables and original key for the edited variable.
        if (temp.varName != envData.varName && temp.varName !== envData.originalKey) {
          allNames.push(temp.varName);
        }
        else {
          allNames.push(temp.varName);
          ctr++;
        }
      });
      // }
      // else {
      //   if (service) {
      //     service.envs.map((temp) => {
      //       if (temp.varName != data.varName) {
      //         allNames.push(temp.varName);
      //       }
      //     });
      //   } 
      // }

      console.log("ALL NAMES: ", allNames, allNames.includes(envData.varName), ctr);

      if (allNames.includes(envData.varName) && ctr > 1) {
        setError({
          status: true,
          msg: "Variable name already exist. Please provide unique variable name."
        });
        form.setFields([{
          name: "varName",
          errors: ["Variable name already exist. Please provide unique variable name."]
        }]);
      }
      else if (envData.varName.startsWith(" ") || envData.varName.endsWith(" ")) {
        setError({
          status: true,
          msg: "Please remove any leading or trailing spaces from variable name."
        });
      }
      else {
        setError({ ...error, status: false });
        console.log("Data.tempId: ", data);
        currentProject.tasks.map((temp, idx) => {
          if (!fromEnvironment ? (temp.id === data.serviceId || idx === data.tempId) : temp.serviceId === data.tempId) {
            const envs = Array.isArray(currentProject.tasks[idx].envs) ? currentProject.tasks[idx].envs.filter(Boolean) : [];
            // Match by env-specific id (row index). If id is absent (envs loaded via direct push
            // without id assigned), fall back to originalKey / varName so we never push a duplicate.
            const originalKey = data.originalKey || data.varName || data.keys;
            const envIndex = envs.findIndex((e) => e && (
                e.id !== undefined ? e.id === data.id : (e.varName === originalKey || e.originalKey === originalKey)
            ));
            const updatedEnv = { ...envData, id: data.id, lastAction: "Update", valueFrom: envData.dependOn ? "Value From" : (envData.valueFrom || "Value") };
            if (envIndex >= 0) {
              envs[envIndex] = updatedEnv;
            } else {
              envs.push(updatedEnv);
            }
            currentProject.tasks[idx].envs = envs;
          }
        });

        if (!fromEnvironment) {
          currentProject.tasks[selectedAppId].appError = false;
        }
        console.log("My new currentProject: ", currentProject);
        // setCurrentProject({ ...currentProject, tasks: [...currentProject.tasks] });
        // localStorage.setItem(!fromEnvironment ? "Project" : "ProjectDep", JSON.stringify({ ...currentProject, tasks: [...currentProject.tasks] }));
        console.log("Entering api call.....");

        if (!hasChanges) {
          if (!fromEnvironment) {
            if (envData.isSecret && (currentProject.tasks[selectedAppId].is_secret_manager || currentProject?.accountDetails?.account_id)) {
              console.log("getting env vars....");
              handelSaveEnvVar(true);
            }
            else {
              handelSaveEnvVar(false);
            }
          }
          else {
            if (envData.syncProj) {
              if (envData.isSecret && selectedAccountDetails?.account_id) {
                console.log("getting env vars....");
                // handelSaveEnvVar(true);
                handelSaveEnvVar(false);
              }
              else {
                handelSaveEnvVar(false);
              }
            }
          }
        }
        else {
          if (fromWorkflow) {
            // pass
          }
          else if (!fromEnvironment) {
            setActionPerformed(true);
          }
        }
        // else {
        //   currentProject.tasks[selectedAppId].updatedVals = [...currentProject.tasks[selectedAppId].updatedVals, envData];
        // }
        if (!fromEnvironment) {
          const myService = currentProject?.tasks[selectedAppId];
          console.log("My service: ", myService);
          const envNameMap = new Map();
          const envsArr = Array.isArray(myService?.envs) ? myService.envs.filter(Boolean) : [];
          for (let i = envsArr.length - 1; i >= 0; i--) {
            const env = envsArr[i];
            envNameMap.set(env.varName, envNameMap.get(env.varName) ? envNameMap.get(env.varName) + 1 : 1);
            const total = envNameMap.get(env.varName);
            console.log("Total...", env.varName, total);
            env.error = (total || env.value === "" || env.varName === "" ? total > 1 || env.value === "" || env.varName === "" : false);
          }
          myService.envs = envsArr;
          if (!hasChanges) {
            const envById = myService.envs.find((e) => e && (e.id === envData.id || e.tempId === envData.tempId));
            if (envById) {
              envById.originalKey = envById.varName;
            }
          }
        }
        else {
          const envNameMap = new Map();
          if (selectedService) {
            const selectedEnvsArr = Array.isArray(selectedService.envs) ? selectedService.envs.filter(Boolean) : [];
            for (let i = selectedEnvsArr.length - 1; i >= 0; i--) {
              const env = selectedEnvsArr[i];
              envNameMap.set(env?.varName, envNameMap.get(env?.varName) ? envNameMap.get(env?.varName) + 1 : 1);
              const total = envNameMap.get(env?.varName);
              env.error = (total || env?.value === "" || env?.varName === "" ? total > 1 || env?.value === "" || env?.varName === "" : false);
            }
            selectedService.envs = selectedEnvsArr;
            if (envData.isSecret && selectedAccountDetails?.account_id) {
              console.log("Getting the proj: ", selectedService, envData);
              const envById = selectedService.envs.find((e) => e && (e.id === envData.id || e.tempId === envData.tempId));
              if (envById) {
                envById.originalKey = envById.varName;
              }
            }
          }
        }
        // Compact envs (remove null/undefined) for all tasks before persisting
        const tasksWithCompactEnvs = currentProject.tasks.map((task) => ({
          ...task,
          envs: Array.isArray(task.envs) ? task.envs.filter(Boolean) : (task.envs || [])
        }));
        setCurrentProject({ ...currentProject, tasks: tasksWithCompactEnvs });
        localStorage.setItem(!fromEnvironment ? "Project" : "ProjectDep", JSON.stringify({ ...currentProject, tasks: tasksWithCompactEnvs }));
        // setHasChanges(true);
        handelClick();
      }
      // }
    }
    catch (err) {
      const firstErrorField = err?.errorFields?.[0]?.name;
      if (firstErrorField && form.scrollToField) {
        form.scrollToField(firstErrorField, { behavior: "smooth", block: "center" });
      } else if (typeof window !== "undefined" && window.scrollTo) {
        window.scrollTo({ top: 0, behavior: "smooth" });
      }
      console.log("Inside handelCreate Error :", err);
    }
  }

  const filterOption = (input, option) => {
    if (option.key) {
      return (option?.value.toLowerCase() ?? '').includes(input.toLowerCase());
    }
  }

  function toggleAlert(type, message, description) {

    set_alertOptions(alertOptions => ({
      status: true,
      type: type,
      message: message,
      description: description,
    }));

    // opacity=0 after 10sec
    setTimeout(() => {
      set_alertOptions(alertOptions => ({
        status: false,
        type: type,
        message: message,
        description: description,
      }));
    }, 5 * 1000);
  }

  const handelSaveEnvVar = async (callSecretApi) => {
    let payload = [];
    // let myAppIdx = [];
    let foundEmpty = false;
    let injectFilled = true;
    if (update) {
      payload = updateEnvPayloadGen(callSecretApi, foundEmpty);
    }
    else {
      payload = addEnvPayloadGen(callSecretApi, foundEmpty, envData);
    }
    console.log("Entering check...", callSecretApi);
    console.log("My payload: ", payload);
    if (payload.length > 0 && !fromWorkflow) {
      console.log("My secret api: ", callSecretApi, payload, data);
      !callSecretApi && !fromEnvironment ? api.put(`${process.env.REACT_APP_API_URI}/api/project_env/projects/${currentProject.id}/services-envs/`, payload.filter((val) => !fromEnvironment ? val.id === currentProject.tasks[selectedAppId].serviceId : (val.id === data.serviceId || val.id === data.tempId)))
        .then((res) => {
          let data = res.data;
          console.log("repo/list data :", data);
          if (data.status) {
            toggleAlert("success", "Success", update ? "Environment variable updated successfully." : "Environment variable added successfully.");
            setHasChanges(false);
          }
          else {
            let err = formatErrors(data.msg);
            toggleAlert("error", "Error", err);
          }
          setSavingVars(false);
        })
        .catch((err) => {
          console.log("err :", err);
          toggleAlert("error", "Error", "Something went wrong. Please try again.");
          setSavingVars(false);
        }) :
        !update && callSecretApi ? api.post(`${process.env.REACT_APP_API_URI}/api/project_env/secrets`, payload.find(val => !fromEnvironment ? val.id === currentProject.tasks[selectedAppId].serviceId : (val.id === data.serviceId || val.id === data.tempId)))
          .then((res) => {
            let data = res.data;
            console.log("repo/list data :", data);
            if (data.status) {
              toggleAlert("success", "Success", update ? "Environment variable updated successfully." : "Environment variable added successfully.");
              setHasChanges(false);
            }
            else {
              let err = formatErrors(data.msg);
              toggleAlert("error", "Error", err);
            }
            setSavingVars(false);
          })
          .catch((err) => {
            console.log("err :", err);
            toggleAlert("error", "Error", "Something went wrong. Please try again.");
            setSavingVars(false);
          }) : callSecretApi && api.patch(`${process.env.REACT_APP_API_URI}/api/project_env/secrets`, payload.find((val, idx) => !fromEnvironment ? val.id === currentProject.tasks[selectedAppId].serviceId || idx === data.tempId : (val.id === data.serviceId || val.id === data.tempId)))
            .then((res) => {
              let data = res.data;
              console.log("repo/list data :", data);
              if (data.status) {
                toggleAlert("success", "Success", update ? "Environment variable updated successfully" : "Environment variable added successfully.");
                setHasChanges(false);
                console.log("My var name: ", currentProject.tasks[selectedAppId]?.envs, data);
              }
              else {
                let err = formatErrors(data.msg);
                toggleAlert("error", "Error", err);
              }
              setSavingVars(false);
            })
            .catch((err) => {
              console.log("err :", err);
              toggleAlert("error", "Error", "Something went wrong. Please try again.");
              setSavingVars(false);
            });
      if (fromWorkflow) {
        // pass
      }
      else if (!fromEnvironment) {
        setActionPerformed(true);
      }
    }
  }

  const onCheckboxChange = (checkedValues) => {
    console.log("On changing check box: ", checkedValues);
    setEnvData({
      ...envData,
      injectAt: checkedValues,
      error: checkedValues.length > 0 ? false : true
    });
  }

  return (
    <ProdContentHold className='addEnvVar' style={{}}>
      {console.log("My env var data: ", envData)}
      <div title={(!hasPermission('update_secret') && update && envData.isSecret) && "You don't have permission to perform this action."}>
        <Form
          form={form}
          initialValues={{ ...envData }}
          preserve={false}
          name="dynamic_rule"
          disabled={(!hasPermission('update_secret') && update && envData.isSecret)}
        >
          <Box
            title={<div style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}>
              <span className="header-text">Add Variable</span>
              <img src={closeIcon} style={{ cursor: "pointer", width: "20px", height: "20px", transform: "translateY(15px)" }} alt="close Icon" onClick={handelClick} />
            </div>}
            subtitle="Enter details to add new variable"
            titleStyle={{
              fontWeight: '500',
              fontFamily: "Nunito Sans",
              fontSize: '14px',
              color: "white"
            }}
            subTitleStyle={{
              fontWeight: '400',
              fontFamily: "Nunito Sans",
              fontSize: '13px',
              color: "white"
            }}
            style={{
              position: "absolute",
              zIndex: "1",
              width: "100%",
              top: "0px",
              height: "83px",
              backgroundColor: "rgb(19, 47, 68)"
            }}
          />

          <Box
            title="Variable*"
            subtitle="Variable Name"
            titleStyle={titleStyle}
            subtitleStyle={subTitleStyle}
            style={{
              marginTop: "80px",
            }}
          >
            <Form.Item
              name="varName"
              rules={[
                {
                  required: true,
                  message: 'Please enter variable name',
                }
              ]}
            >
              <Input
                name="varName"
                value={envData.varName}
                onChange={handelInputChange}
                placeholder="Enter Variable here"
                className="envVar-varName"
                style={{ height: "44px" }}
                disabled={(!hasPermission('update_secret') && update && envData.isSecret)}
                data-testid="env-var-name-input"
              />
            </Form.Item>
          </Box>

          <Box
            title={fromWorkflow ? "Variable Type*" : "Value From*"}
            subtitle={fromWorkflow ? "Select variable type" : "Value from details"}
            subtitleStyle={subTitleStyle}
            titleStyle={titleStyle}
            style={{ width: "100%" }}
          >
            <div style={{ width: "100%" }}>
              <Form.Item
                name="valueFrom"
                rules={[
                  {
                    required: true,
                    message: 'This field is required!',
                  },
                ]}
              >
                <Select
                  value={envData.valueFrom}
                  onChange={handleSelectChange}
                  placeholder="Enter Value From here"
                  style={{ width: '100%' }}
                  disabled={((currentProject.importDetails?.secretFile && update && envData.isSecret) || ((currentProject?.accountDetails?.account_id || selectedAccountDetails?.account_id) && envData.isSecret && update))}
                  data-testid="env-var-value-from-select"
                >
                  {myValueFroms}
                </Select>
              </Form.Item>
            </div>
          </Box>

          {fromEnvironment && envData.valueFrom === "Value From" && (
            <Box
              title="Dependent Service*"
              subtitle="Select depends on service for this environment variable."
              titleStyle={titleStyle}
              subtitleStyle={subTitleStyle}
              style={{
                marginTop: "0px",
              }}
            >
              <Form.Item
                name="dependOn"
                rules={[
                  {
                    required: true,
                    message: 'Please select a service',
                  }
                ]}
              >
                <Select
                  value={selectedApplicationId}
                  onChange={handleServiceSelect}
                  placeholder="Select Service"
                  style={{ width: '100%' }}
                  disabled={(!hasPermission('update_secret') && update && envData.isSecret)}
                >
                  {Object.entries(mapIdsWithAppName || {})
                    .filter(([id]) => {
                      if (selectedAppId === null || selectedAppId === undefined || selectedAppId === "") {
                        return true;
                      }
                      return String(id) !== String(selectedAppId);
                    })
                    .map(([id, name]) => (
                      <Option key={id} value={Number.isNaN(Number(id)) ? id : Number(id)}>
                        {name}
                      </Option>
                    ))}
                </Select>
              </Form.Item>
            </Box>
          )}

          <Box
            title={envData.valueFrom === "Value From" ? "Select Value*" : "Value*"}
            subtitle={envData.valueFrom === "Value From" ? "Select dependent service value from dropdown. Values are displayed as <SERVICE_VARIABLE_name>" : "Please enter a value"}
            subtitleStyle={subTitleStyle}
            titleStyle={titleStyle}
          >
            {console.log("envData.valueShown :", envData.valueShown)}
            {envData.valueFrom === "Value From" ?
              <Form.Item
                name={envData.valueFrom === "Value From" ? "valueShown" : "value"}
                rules={[
                  {
                    required: true,
                    message: 'This field is required!',
                  },
                ]}
              >
                <Select
                  // defaultValue={envData.value}
                  showSearch
                  filterSort={(optionA, optionB) => customSortOptions(optionA, optionB, searchValue)} // Custom sorting function
                  filterOption={(inputValue, option) => customFilterOption(inputValue, option)} // Custom filtering function
                  onSearch={(value) => {
                    console.log("Enters search", value);
                    setSearchValue(value);
                  }}
                  value={envData.valueShown ? envData.valueShown : null}
                  optionLabelProp={envData.valueShown}
                  onChange={handleSelectChange}
                  placeholder="Please Select Value"
                  //filterOption={filterOption}
                  style={{ width: "100%" }}
                  data-testid="env-var-value-from-dropdown"
                >
                  {myDropdown}
                </Select>
              </Form.Item>
              :
              <Form.Item
                name="value"
                rules={[
                  {
                    required: true,
                    message: 'This field is required!',
                  },
                ]}
              >
                {envData.isSecret ? (
                  <Input.Password
                    name="value"
                    value={envData.value}
                    onChange={handelInputChange}
                    placeholder="Enter value here"
                    className="envVar-textarea"
                    disabled={(!hasPermission('update_secret') && update && envData.isSecret)}
                    data-testid="env-var-value-input"
                    style={{ height: "44px" }}
                  />
                ) : (
                  <TextArea
                    rows={4}
                    name="value"
                    value={envData.value}
                    onChange={handelInputChange}
                    placeholder="Enter value here"
                    className="envVar-textarea"
                    disabled={(!hasPermission('update_secret') && update && envData.isSecret)}
                    data-testid="env-var-value-input"
                  />
                )}
              </Form.Item>

            }
          </Box>

          <Box
            title={<div style={{ width: "100%", display: "flex", justifyContent: "space-between" }}>
              <div style={{ display: "flex" }}>
                <span style={{ marginRight: "10px" }}>Is this a secret* </span>
                <CustomInfoTooltip title={"Note: any new secret or modification to existing secrets will sync back to the provider."} placement="bottomLeft" />
              </div>
              {console.log("Has permission check...", (!hasPermission('create_secret') || (!hasPermission('update_secret') && update)) && data.isSecret)}
              <Switch
                checked={envData.isSecret}
                onChange={(checked) => {
                  if (!(((currentProject?.accountDetails?.account_id || selectedAccountDetails?.account_id) && data.isSecret && update) || envData.valueFrom === "Value From" || hasChanges)) {
                    // setEnvData({ ...envData, syncProj: checked, isSecret: !envData.isSecret, isHide: !envData.isSecret });
                    setEnvData({ ...envData, syncProj: false, isSecret: !envData.isSecret, isHide: !envData.isSecret });
                    setError({ ...error, status: false });
                  }
                }}
                name="isSecret"
                title={((((!hasPermission('create_secret') && !update) || (!hasPermission('update_secret') && update && data.isSecret)))) ? "You don't have permission to perform this action." : (/*(currentProject?.accountDetails?.account_id && data.isSecret && update) || envData.valueFrom === "Value From" ||*/ hasChanges) ? "Please save the existing variables first." : (((currentProject?.accountDetails?.account_id || selectedAccountDetails?.account_id) && data.isSecret && update) || envData.valueFrom === "Value From") && "This action is not permitted for the existing variable configuration."}
                disabled={(/*(currentProject?.accountDetails?.account_id && data.isSecret && update) || envData.valueFrom === "Value From" ||*/ (((!hasPermission('create_secret') && !update) || (!hasPermission('update_secret') && update && data.isSecret))) /*|| hasChanges*/)}
                style={{ backgroundColor: envData.isSecret && "#132f44", opacity: ((currentProject?.accountDetails?.account_id && data.isSecret && update) || envData.valueFrom === "Value From" || hasChanges) && "0.7", cursor: ((currentProject?.accountDetails?.account_id && data.isSecret && update) || envData.valueFrom === "Value From" || hasChanges) && "not-allowed" }}
                data-testid="env-var-secret-toggle"
              /></div>}
            subtitle="Toggle the switch to enable secret variable."
            titleStyle={titleStyle}
            subtitleStyle={subTitleStyle}
          >
          </Box>
          {/* {!fromEnvironment && !fromWorkflow && <Box
            title={<div style={{ width: "100%", display: "flex", justifyContent: "space-between" }}>
              <div style={{ display: "flex" }}>
                <span style={{ marginRight: "10px" }}>Sync back to project* </span>
                <CustomInfoTooltip title={"Note: any new secret or modification to existing secrets will sync back to the provider."} placement="bottomLeft" />
              </div>
              <Switch
                checked={envData.syncProj}
                disabled={envData.isSecret}
                onChange={() => {
                  setEnvData({ ...envData, syncProj: !envData.syncProj });
                  setError({ ...error, status: false });
                }}
                name="syncProj"
                // disabled={envData.importFrom === "Secret Manager"}
                style={{ backgroundColor: envData.syncProj && "#132f44" }}
              /></div>}
            subtitle="Toggle the switch to sync these variables with the project."
            titleStyle={titleStyle}
            subtitleStyle={subTitleStyle}
          >
          </Box>} */}

          {!fromWorkflow && <Box
            title="Environment variable type"
            subtitle="Select environment variable type"
            subtitleStyle={subTitleStyle}
            titleStyle={titleStyle}
            style={{ width: "100%" }}
          >
            <Form.Item name="injectAt" rules={[
              {
                required: true,
                message: "Please select environment variable type"
              }
            ]}>
              <Checkbox.Group className="env-vars-group" name="injectAt" value={envData.injectAt} onChange={onCheckboxChange} style={{ marginTop: "15px" }}>
                {/* Do not show build time option in case of update environment as it will now be modified under the workflow section */}
                {((!fromEnvironment) || (fromEnvironment && !updateDep)) && (
                  <Tooltip title={!fromEnvironment ? (currentProject.tasks[selectedAppId].sourceType === "Container Registry" ? "Build time variables are not available for Container Registry source type." : "") : ((currentProject?.tasks?.find(val => val.serviceId === selectedAppId).app_source_type === 0) ? "Build time variables are not available for Container Registry source type." : (updateDep ? "Build time variables are not available while service update." : ""))}>
                    <span>
                      <Checkbox name="Build Time" value={"Build Time"} disabled={(!fromEnvironment ? (currentProject.tasks[selectedAppId].sourceType === "Container Registry") : (selectedService?.tasks?.find(val => val.serviceId === selectedAppId).app_source_type === 0) || (updateDep))} style={{ border: "1px solid", borderRadius: "8px", marginRight: "10px", color: "#1f1f1f !important", padding: "13px" }} data-testid="env-var-build-time-checkbox">Build Time</Checkbox>
                    </span>
                  </Tooltip>
                )}
                {!fromWorkflow && <Checkbox name="Run Time" value={"Run Time"} style={{ border: "1px solid", padding: "10px", borderRadius: "8px", color: "#1f1f1f !important", padding: "13px" }} data-testid="env-var-run-time-checkbox">Run Time</Checkbox>}
              </Checkbox.Group>
            </Form.Item>
            <ContentHolder style={{ marginTop: "12px" }}>
              {error.status && <p className="isoHelperText">
                <span>{error.msg}</span>
              </p>}
            </ContentHolder>
          </Box>}
          <div style={{ height: "84px" }}></div>


          <div style={{
            position: "absolute",
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "84px",
            bottom: "0",
            borderTop: "1px solid #e9e9e9",
            zIndex: "1000",
            background: "white",
          }}>
            {!update ?
              <Button style={{
                padding: '10px 50px',
                backgroundColor: "#132F44",
                width: "164px",
                height: "44px",
                border: '1px solid #D9D9D9',
                borderRadius: '8px',
                color: "white",
                marginRight: "15px"
              }}
                onClick={(e) => {
                  handelCreate(e, false);
                  // handelSaveEnvVar();
                }}
                data-testid="env-var-create-btn"
              >Create</Button>
              :
              <Button style={{
                padding: '10px 50px',
                backgroundColor: "#132F44",
                width: "164px",
                height: "44px",
                border: '1px solid #D9D9D9',
                borderRadius: '8px',
                color: "white",
              }}
                onClick={handelUpdate}
                data-testid="env-var-update-btn"
              >Update</Button>
            }

            {!update && <Button style={{
              padding: '10px 14px',
              backgroundColor: "transparent",
              width: "188px",
              height: "44px",
              border: '1px solid #132F44',
              borderRadius: '8px',
              color: "#132F44"
            }}
              onClick={(e) => {
                handelCreate(e, true);
              }}
              data-testid="env-var-create-and-add-another-btn"
            >Create & Add another</Button>}
          </div>
        </Form>
      </div>
    </ProdContentHold >
  );
};